Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '';
__p += '<div class="d-flex">\n  <button class="btn btn-secondary" ref="' +
((__t = (ctx.ref)) == null ? '' : __t) +
'">\n    <i class="fa fa-barcode component-icon"></i> ' +
((__t = (ctx.label)) == null ? '' : __t) +
'\n  </button>\n  <div class="info-text">\n    ' +
((__t = (ctx.dataValue ? ctx.dataValue : 'No code')) == null ? '' : __t) +
'\n  </div>\n</div>\n';
return __p
}